import { type FunctionComponent } from 'react';
import classes from './Loader.module.css';
import cx from 'clsx';
import {
  ActivityDesignMeaning,
  BrandDesignMeaning,
  DefaultDesignMeaning,
} from '@/types/design-semantics';
import Icon from '@/components/Icon';

export interface LoaderProps {
  alt?: string;

  /** The semantic coloring of the icon. */
  meaning?: DefaultDesignMeaning | BrandDesignMeaning | ActivityDesignMeaning;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'lxl' | 'xl' | 'xxl';
  className?: string;
}

/**
 * Loader
 *
 * A rotating icon to indicate loading state.
 */
const Loader: FunctionComponent<LoaderProps> = ({
  alt = 'Loading…',
  meaning = 'primary',
  size = 'xl',
  className,
}) => {
  return (
    <div className={cx(classes.root, className)}>
      <Icon
        name="custom/refresh-cw"
        variant="filled"
        className={classes.icon}
        size={size}
        meaning={meaning}
        alt={alt}
      />
    </div>
  );
};

export default Loader;
